import { useEffect, useRef, useState } from 'react';
import { isMobile } from '../../../utils/utils';

interface Nota {
  id: number;
  attributes: Record<string, unknown>;
}

// Debe coincidir con el `pageSize` que usa `getServerSideProps` de la página
// para la primera página (sin filtros), así el primer fetch client-side no
// pisa el resultado del SSR con una cantidad de items distinta.
const RESULTS_PER_PAGE = 10;

const useHook = ({ notas }: { notas: Nota[] }) => {

  const [mobile, setMobile] = useState(true);

  const [tipo, setTipo] = useState('');
  const [tematica, setTematica] = useState('');

  const [notasHydratated, setNotasHydratated] = useState<Nota[]>(notas);
  const [loadingNotas, setLoadingNotas] = useState(false);
  const fetchAbortRef = useRef<AbortController | null>(null);
  const isFirstRender = useRef(true);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  const handleTipo = (e: string) => {
    setTipo(e);
  };

  const handleTematica = (e: string) => {
    setTematica(e);
  };

  const fetchNotas = async () => {
    fetchAbortRef.current?.abort();
    const abortController = new AbortController();
    fetchAbortRef.current = abortController;

    setLoadingNotas(true);

    const body = {
      page,
      pageSize: RESULTS_PER_PAGE,
      sort: "score%3Adesc",
      tipo: tipo.trim(),
      tematica: tematica.trim(),
    };

    try {
      const result = await fetch(`${process.env.NEXT_PUBLIC_URL_FRONTEND}/api/notas/get-filtered`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
        signal: abortController.signal,
      });
      const data = await result.json();
      if (data?.data) {
        setNotasHydratated(data.data || []);
        setTotalPages(Math.ceil(data?.meta?.pagination?.total / RESULTS_PER_PAGE));
      }
      setLoadingNotas(false);
    } catch (err) {
      if ((err as Error)?.name === 'AbortError') return;
      console.log("e", err);
      setLoadingNotas(false);
    }
  };

  useEffect(() => {
    setMobile(isMobile());
  }, []);

  useEffect(() => {
    // La página 1 sin filtros ya viene resuelta por SSR (prop `notas`):
    // saltea el primer fetch para no duplicar ese request.
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    fetchNotas();
    return () => {
      fetchAbortRef.current?.abort();
    };
  }, [page, tipo, tematica]);

  return {
    mobile,
    tipo,
    handleTipo,
    tematica,
    handleTematica,
    notasHydratated,
    totalPages,
    page,
    setPage,
  };
};

export default useHook;
